import "./tag.scss";

import { Link } from "gatsby";
import * as React from "react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { ILink, TypeCTA } from "../../../types/thecookies";
import DoNotMountComponent from "../../DoNotMountComponent/DoNotMountComponent";
import { getLink } from "../../Shared/Utils/getLink";
import { getSlugWithLang } from "../../Shared/Utils/getSlugWithLang";

export type TagSettings = {
  color?: "blue" | "green" | "red" | "orange" | null | undefined;
  callback?: () => void;
  size?: "small" | "medium" | "large";
};

export type PropsTag = PropsWithChildren<{
  tag: ILink;
  setting?: TagSettings;
}>;

const Tag: React.FC<PropsTag> = (props: PropsTag) => {
  const { tag } = props;
  if (!tag) return <DoNotMountComponent sms={"No existe el Tag"} />;
  const color = props.setting?.color ? props.setting.color : "green";
  const size = props.setting?.size ? props.setting.size : "medium";
  const tagName = tag.name || (tag as string);
  const { i18n } = useTranslation();

  const whatCta = () => {
    if (tag.render) {
      switch (tag.render) {
        case TypeCTA.LINK:
          tagLink();
          break;
        case TypeCTA.BUTTON:
          return (
            <button
              onClick={props.setting?.callback}
              className={`m-tag m-tag--${color} size--${size}`}
            >
              {getTextWithHashtag(tagName)}
            </button>
          );
        case TypeCTA.SPAN:
          return (
            <span className={`m-tag m-tag-span--${color} size--${size}`}>
              {getTextWithHashtag(tagName)}
            </span>
          );
        default:
          return (
            <span className={`m-tag m-tag-span--${color} size--${size}`}>
              {getTextWithHashtag(tagName)}
            </span>
          );
      }
    }
  };
  const tagLink = () => {
    if (tag.name && tag.slug) {
      if (tag.slug.startsWith("https") || tag.slug.startsWith("http")) {
        return (
          <a
            href={getLink(tag.slug)}
            className={`m-tag m-tag--${color} size--${size}`}
          >
            {getTextWithHashtag(tagName)}
          </a>
        );
      } else {
        return (
          <Link
            to={getLink(tag.slug)}
            className={`m-tag m-tag--${color} size--${size}`}
          >
            {getTextWithHashtag(tagName)}
          </Link>
        );
      }
    }
  };

  function getTextWithHashtag(tag: string): string {
    const words = tag.split(" ");
    const joinedText = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join("");
    return `#${joinedText}`;
  }

  // FLUJO DE DATOS ----------------------------------------------------------------------------------------

  if (props.setting?.callback) {
    if (!tag.render) {
      return (
        <button
          onClick={tag.render}
          className={`m-tag m-tag--${color} size--${size}`}
        >
          {getTextWithHashtag(tagName)}
        </button>
      );
    } else {
      return whatCta();
    }
  }
  if (tag.render) {
    return whatCta();
  }

  if (tag.name && tag.slug) {
    return (
      <Link
        to={getSlugWithLang(`/thebakery/${tag.slug}/`, i18n.language)}
        className={`m-tag m-tag--${color} size--${size}`}
      >
        {getTextWithHashtag(tagName)}
      </Link>
    );
  }

  if (tag.name) {
    return (
      <span className={`m-tag m-tag-span--${color} size--${size}`}>
        {getTextWithHashtag(tagName)}
      </span>
    );
  }
  return (
    <span className={`m-tag m-tag-span--${color} size--${size}`}>
      {getTextWithHashtag(tagName)}
    </span>
  );
};

export default Tag;
